import React from "react";
import { Alert } from "@material-ui/lab";
import { makeStyles, Icon, Typography } from "@material-ui/core";
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    margin: 10,
  },
}));

export default function Dashboard() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Alert icon={false} severity="info">
        <h1>
          <Icon fontSize="large">dashboard</Icon>

          <Typography variant="h4" gutterBottom>
            {" "}
            Welcome to Budget & Financial Control System
          </Typography>
        </h1>
      </Alert>
    </div>
  );
}
